import { apiClient } from 'src/careflow/ph-core/api_client/api_client';

const workflow = 'workflow';
const workflowInstance = 'workflow/instance';
const workflowTransitions = 'workflow/transitions';
const checklist = 'checklist';
const transition = 'transition';

const WorkflowApi = {
  getWorkflowByCode: async (code: any): Promise<any> =>
    apiClient.get<any>(`${workflow}/?code=${code}`),
  getWorkflowByType: async (type: string): Promise<any> =>
    apiClient.get<any>(`${workflow}/?type=${type}`),
  getTransitions: async (workFlow: any): Promise<any> =>
    apiClient.get<any>(`${workflowTransitions}?workFlow=${workFlow}`),
  getInstance: async (referenceValue: any, referenceName: any): Promise<any> =>
    apiClient.get<any>(
      `${workflowInstance}?referenceName=${referenceName}&referenceValue=${referenceValue}`
    ),
  dbAttribute: async (data: any): Promise<any> =>
    apiClient.post<any, any>(`${workflowInstance}/dbattribute`, data),
  assignOwner: async (data: any): Promise<any> =>
    apiClient.post<any, any>(`${workflowInstance}/assignOwner`, data),
  reAssignOwner: async (data: any): Promise<any> =>
    apiClient.post<any, any>(`${workflowInstance}/reAssignOwner`, data),
  fhirAttribute: async (data: any): Promise<any> =>
    apiClient.post<any, any>(`${workflowInstance}/fhirattribute`, data),
  updateWorkflowInstance: async (data: any): Promise<any> =>
    apiClient.put<any, any>(`${workflowInstance}/update`, data),
  updateRecordByAttribute: async (data: any): Promise<any> =>
    apiClient.put<any, any>(`${workflowInstance}`, data),
  getChecklistByCode: async (code: any): Promise<any> =>
    apiClient.get<any>(`${checklist}/code?code=${code}`),
  getChecklistById: async (data: any): Promise<any> =>
    apiClient.post<any, any>(`${checklist}/allChecklist`, data),
  confirmChecklistItems: async (data: any): Promise<any> =>
    apiClient.post<any, any>(`${checklist}/confirmChecklistItems`, data),
  markItemCompleted: async (data: any): Promise<any> =>
    apiClient.post<any, any>(`${checklist}/completed`, data),
  checkItemsValid: async (data: any): Promise<any> =>
    apiClient.post<any, any>(`${checklist}/checkItemsValid`, data),
  deleteCheckItemSaved: async (data: any): Promise<any> =>
    apiClient.post<any, any>(`${checklist}/checkItemSaved`, data),
  attempt: async (data: any): Promise<any> =>
    apiClient.post<any, any>(`${transition}/attempt/`, data),
  updateStage: async (data: any): Promise<any> =>
    apiClient.put<any, any>(`${transition}/stage/`, data),
  resetWorkflow: (data: { referenceName: string; referenceValue: string }) =>
    apiClient.post<any, any>(`core/${workflowInstance}/reset`, data),
  clearStep: (data: { referenceName: string; referenceValue: string; checklistItemCode: string }) =>
    apiClient.post<any, any>(`core/${workflowInstance}/step/clear`, data),
  validateWorkflowCondition: (data: any) => apiClient.post<any, any>(`${workflow}/validate`, data),
};

export const WorkflowService = {
  getWorkflowByCode: async (code: any): Promise<any> => {
    const workflowByCode = await WorkflowApi.getWorkflowByCode(code);
    if (!workflowByCode) return undefined;
    return workflowByCode;
  },
  getWorkflowByType: async (type: string): Promise<any> => {
    const workflowByType = await WorkflowApi.getWorkflowByType(type);
    if (!workflowByType) return undefined;
    return workflowByType;
  },
  getTransitions: async (workFlow: any): Promise<any> => {
    const transitions = await WorkflowApi.getTransitions(workFlow);
    if (!transitions) return undefined;
    return transitions;
  },
  getInstance: async (referenceValue: any, referenceName: any): Promise<any> => {
    const instance = await WorkflowApi.getInstance(referenceValue, referenceName);
    if (!instance) return undefined;
    return instance;
  },
  dbAttribute: async (data: any): Promise<any> => {
    const attribute = await WorkflowApi.dbAttribute(data);
    if (!attribute) return undefined;
    return attribute;
  },
  assignOwner: async (data: any): Promise<any> => {
    const owner = await WorkflowApi.assignOwner(data);
    if (!owner) return undefined;
    return owner;
  },
  reAssignOwner: async (data: any): Promise<any> => {
    const owner = await WorkflowApi.reAssignOwner(data);
    if (!owner) return undefined;
    return owner;
  },
  fhirAttribute: async (data: any): Promise<any> => {
    const attribute = await WorkflowApi.fhirAttribute(data);
    if (!attribute) return undefined;
    return attribute;
  },
  updateWorkflowInstance: async (data: any): Promise<any> => {
    const instance = await WorkflowApi.updateWorkflowInstance(data);
    if (!instance) return undefined;
    return instance;
  },
  updateRecordByAttribute: async (data: any): Promise<any> => {
    const recordByAttribute = await WorkflowApi.updateRecordByAttribute(data);
    if (!recordByAttribute) return undefined;
    return recordByAttribute;
  },
  getChecklistByCode: async (code: any): Promise<any> => {
    const checklistByCode = await WorkflowApi.getChecklistByCode(code);
    if (!checklistByCode) return undefined;
    return checklistByCode;
  },
  getChecklistById: async (data: any): Promise<any> => {
    const checklistById = await WorkflowApi.getChecklistById(data);
    if (!checklistById) return undefined;
    return checklistById;
  },
  confirmChecklistItems: async (data: any): Promise<any> => {
    const checklistItems = await WorkflowApi.confirmChecklistItems(data);
    if (!checklistItems) return undefined;
    return checklistItems;
  },
  markItemCompleted: async (data: any): Promise<any> => {
    const itemCompleted = await WorkflowApi.markItemCompleted(data);
    if (!itemCompleted) return undefined;
    return itemCompleted;
  },
  checkItemsValid: async (data: any): Promise<any> => {
    const itemsValid = await WorkflowApi.checkItemsValid(data);
    if (!itemsValid) return undefined;
    return itemsValid;
  },
  deleteCheckItemSaved: async (data: any): Promise<any> => {
    const checkItemSaved = await WorkflowApi.deleteCheckItemSaved(data);
    if (!checkItemSaved) return undefined;
    return checkItemSaved;
  },
  attempt: async (data: any): Promise<any> => {
    const attempt = await WorkflowApi.attempt(data);
    if (!attempt) return undefined;
    return attempt;
  },
  updateStage: async (data: any): Promise<any> => {
    const stage = await WorkflowApi.updateStage(data);
    if (!stage) return undefined;
    return stage;
  },
  resetWorkflow: async (data: { referenceName: string; referenceValue: string }) => {
    const reset = await WorkflowApi.resetWorkflow(data);
    if (!reset) return undefined;
    return reset;
  },
  clearStep: async (data: {
    referenceName: string;
    referenceValue: string;
    checklistItemCode: string;
  }) => {
    const clear = await WorkflowApi.clearStep(data);
    if (!clear) return undefined;
    return clear;
  },
  validateWorkflowCondition: async (data: any) => {
    const validate = await WorkflowApi.validateWorkflowCondition(data);
    if (!validate) return undefined;
    return validate;
  },
};
